import { billingAddressStyles as styles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsCreditCardBillingAddress";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    variant: "h6",
    css: css`
        ${styles.titleText?.css}
        font-size: 14px;
        margin-bottom: 4px;
        margin-top: 16px;
        padding: 0;
    `,
};

styles.addressDisplay = {
    ...styles.addressDisplay,
    wrapper: {
        ...styles.addressDisplay?.wrapper,
        css: css`
            p {
                line-height: 180%;
            }
        `,
    },
};
